module.exports = {"id":"212048","name":"Alexandru Chipciu","rating":"72","photo":"./data/images/photos/0/212048.png","club":{"name":"RSC Anderlecht","logo":"./data/images/clubs/RSCAnderlecht.png"},"positions":["MD"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AlexandruChipciu0.json
// module id = 260
// module chunks = 0